import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as Action from "../../../store/redux_computer_base/student_computer_base_reducer.js";
import axios from "axios";
import IsLoading from "../../../isLoading.jsx";
// QEUEE Slider __________________________________________________________________________________
let queue;
let answerFill;

export default function StudentCBTExamsLogin() {
  const [loading, setLoading] = useState(false);
  const redirect = useNavigate();
  const dispatch = useDispatch();

  // funtions for getting student into the examination base software

  const startExamination = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_SERVER_SCRIPT_HOST}/apiget_exam_queues`)
      .then((response) => {
        queue = response.data.info;

        // FUNCTIONS FOR SETTING STUDENT ANSWERS FIELDS ACCORDING TO THE TOTAL NUMBER OF QUESTIONS OF EACH SUBJECT
        answerFill = response.data.info.map((item) =>
          Array(item.questions.length).fill(undefined)
        );

        // FUNCTIONS FOR LOADING SUBJECTS AND THEIR QUESTIONS
        dispatch(DispatchStartExamination());
        redirect("/student_profile/assessment");
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const DispatchStartExamination = () => async (dispatch) => {
    try {
      dispatch(Action.executeExamsAction({ queue, answerFill }));
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {loading ? <IsLoading /> : null}
      <section className="sectionVerifyCBTExams">
        <input type="text" />
        <input type="text" />
        <input type="text" />
        <button
          onClick={() => startExamination()}
          style={{
            backgroundColor: "green",
            color: "white",
            padding: "1.2rem",
          }}
        >
          Login to Start your Exams
        </button>
      </section>
    </>
  );
}
